// paths.js
var DKT = DKT || {};
DKT.paths = function(
  $,
  tamborradasAdultos,
  tamborradasEspeciales,
  tamborradasInfantiles,
  actualLanguage,
  selectedTamborradaId
) {
  var tamborradas;
  var isInfantilPage = false;
  var isSpecialPage = false;

  function init() {
    if (!isInfantilPage && !isSpecialPage) {
      preProccessTamborradas(tamborradasAdultos);
    }
  }

  function initSpecialPage() {
    isSpecialPage = true;
    preProccessTamborradas(tamborradasEspeciales);
    changeParticipantNumberSpecial();    
  }

  function initInfantilPage() {
    isInfantilPage = true;
    preProccessTamborradas(tamborradasInfantiles);
    changeParticipantNumberInfantil();
    var infantilData = getInfantilData();
    var tamborrada = infantilData[0];
    colorizeHours(tamborrada);
  }

  function preProccessTamborradas(preTamborradas) {
    preTamborradas.forEach(function(tamborrada) {
      tamborrada.startTime = new Date(tamborrada.startTime);
      tamborrada.endTime = new Date(tamborrada.endTime);
      tamborrada.id = getTamborradaIdWithLanguage(tamborrada);
    });
    tamborradas = preTamborradas;
  }

  function getStartingPoints(tamborradas) {
    var startingPoints = tamborradas.map(function(tamborrada) {
      return tamborrada.path[0];
    });
    return startingPoints;
  }

  function getSelectedTamborradaData() {
    if (!selectedTamborradaId) {
      selectedTamborradaId = "28";
      console.warn(
        'No se ha encontrado el parametro "selectedTamborradaId". Se ha cogido el id 28 (Bidebieta) por defecto.'
      );
    }
    var tamborradaData = tamborradas.filter(function(tamborrada) {
      return selectedTamborradaId === tamborrada.id;
    });

    return tamborradaData;
  }

  function getTamborradaIdWithLanguage(tamborrada) {
    if (actualLanguage == "es-ES") {
      return tamborrada.id_es;
    } else {
      return tamborrada.id_eu;
    }
  }

  function getTamborradaPairId(id) {
    var pairId = null;
    if (actualLanguage == "es-ES"){
      var pairTamborrada = tamborradas.find(tamborrada => tamborrada.id_es == id) || {};
      if (pairTamborrada.id_eu) pairId = pairTamborrada.id_eu;
    }else{
        var pairTamborrada = tamborradas.find(tamborrada => tamborrada.id_eu == id) || {};
        if (pairTamborrada.id_es) pairId = pairTamborrada.id_es;
    }

    return pairId;
  }

  function getInfantilData() {
    var infantilData = tamborradas.filter(function(tamborrada) {
      return tamborrada.id === "infantil";
    });

    return infantilData;
  }

  function changeParticipantNumberSpecial() {
    var tamborradasTotal = tamborradas.length;
    var male = 0;
    var female = 0;
    var total = 0;

    tamborradas.forEach(function (item) {
      male += item.participants.male;
      female += item.participants.female;
      total += item.participants.total;
    });

    $('#tamborradas-total').text(tamborradasTotal);
    $('#participants-total').text(total);
    $('#participants-male').text(male);
    $('#participants-female').text(female);
  }

  function changeParticipantNumberInfantil() {
    var tamborradasTotal = tamborradas.length - 1;
    var infantilData = getInfantilData();

    $("#tamborradas-total").text(tamborradasTotal);
    $("#participants-total").text(infantilData[0].participants.total);
    $("#participants-male").text(infantilData[0].participants.male);
    $("#participants-female").text(infantilData[0].participants.female);
  }

  function colorizeHours(tamborrada) {
    var now = new Date();
    if (now.getTime() > tamborrada.startTime.getTime()) {
      if (now.getTime() < tamborrada.endTime.getTime()) {
        $(".h-salida").each(function() {
          $(this).addClass("text-danger");
        });
      } else {
        $(".hora").each(function() {
          $(this).addClass("finalizada");
        });
      }
    }
  }

  return {
    init: init,
    initSpecialPage: initSpecialPage,
    initInfantilPage: initInfantilPage,
    getTamborradas: function() {
      return tamborradas.slice(0);
    },
    getInfantilData: getInfantilData,
    getStartingPoints: getStartingPoints,
    getSelectedTamborradaData: getSelectedTamborradaData,
    getTamborradaIdWithLanguage: getTamborradaIdWithLanguage,
    getTamborradaPairId: getTamborradaPairId,
    colorizeHours: colorizeHours
  };
};
